import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet";
import Lodinging from "../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';
import Header from '../master_root/header';
 
import Joblist from './jobs-list';
import JobApplied from './job-applied';
import Statusbar from '../master_root/statusbar';
//page links  
export default function CompanyManagement() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [guid, setGuid] = useState("");
  const [uid, setuid] = useState('');
  const [CompanysUi, setCompanysUi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [loginisOpen, loginsetIsOpen] = useState(false);
  const [Selected, setSelected] = useState('Overview');

  useEffect(() => {
    // checkUserAuth(setUser);
    const existingUser = Cookies.get("guid");
    if (existingUser != null) {
      setGuid(existingUser);
      loginsetIsOpen(true);
    } else {
      navigate = '/';
      loginsetIsOpen(false);
    }
    setuid(searchParams.get("uid"));
  }, []);
  //comanys 

  useEffect(() => {
    if (!uid || !guid) return; // ✅ Only run if both uid and guid are available

    const fetchcompanys = async () => {
      try {
        const q = query(
          collection(db, "companys"),
          where("guid", "==", guid),
          where("uid", "==", uid)
        );

        const companysSnapshot = await getDocs(q);
        if (companysSnapshot.empty) {
          setCompanysUi([]); // Empty result
          setIsLoading(false);
          return;
        }

        const companysList = companysSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setCompanysUi(companysList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching companys:", error);
        setIsLoading(false);
      }
    };

    fetchcompanys();
  }, [uid, guid]); // ✅ Include guid too

  return (
    <div >
      <Statusbar data={'Company management'} />
      <div className='app_header_height'></div>
      <div className="container_roots">

        <Helmet>
          <title>EditorTask - Company Management</title>

          <meta name="description" content="Explore freelance opportunities, post job tasks, or showcase your creative work on EditorTask. Connecting job seekers and employers across India." />
          <meta name="keywords" content="job portal, freelance jobs, editor showcase, hire editors, post jobs, portfolio platform, task marketplace, India jobs, design gigs, video editing work" />
          <meta name="author" content="editortask.com" />
          <meta name="robots" content="index, follow" />

          <meta property="og:title" content="EditorTask - India’s Trusted Platform for Jobs & Creative Talent" />
          <meta property="og:description" content="Find talent or your next opportunity on EditorTask. Post tasks, showcase creative work, and hire skilled editors and freelancers." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.editortask.com/" />
          <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        </Helmet>

        <div className="container_size">
          
          <div className="companys-grid">
            {isLoading ? (
              <Lodinging />
            ) : (
              (() => {

                return CompanysUi.map((companyuilist, index) => {
                  return (

                    <div
                      className="companys-items"
                      onClick={() => navigate(`/m?uid=${companyuilist.slug}`)}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        className="company-logo"
                        src={companyuilist.logo}
                        alt="Logo"
                        onLoad={() => setLoading(false)}
                        onError={() => setLoading(false)} // also hides loader if there's an error
                        style={{ display: loading ? 'none' : 'block' }} // hide img while loading
                      />
                      <div className='items-box'>
                        <div className="items-name">{companyuilist.companyname}</div>
                        <div className="items-hiring"><FaStar className='items-rating' />{companyuilist.rating + "  |  " + companyuilist.reviws + " reviews"}</div>
                      </div> 
                    </div>

                  );
                });
              })()
            )}
          </div>   
        </div>
      </div>
    </div>
  );
}
